import algoliasearch from 'algoliasearch';

import { IAlgoliaSearchService } from '../types/IAlgoliaSearchService';
import { IEntrySearchResultResponse } from '../types/IEntrySearchResultResponse';

export const createAlgoliaSearchService = (
	appId: string,
	readOnlyApiKey: string,
	searchIndex: string,
): IAlgoliaSearchService => {
	const client = algoliasearch(appId, readOnlyApiKey);
	const index = client.initIndex(searchIndex);

	const getSearchResults = async (
		query: string,
		tag: string,
		offset: number,
	) => {
		const result = await index.search<IEntrySearchResultResponse>(query, {
			attributesToSnippet: ['title', 'bodyString:30'],
			attributesToRetrieve: ['id', 'slug', 'pageId'],
			attributesToHighlight: [],
			snippetEllipsisText: '…',
			filters: `tags:${tag}`,
			hitsPerPage: offset,
		});

		return result;
	};

	return { getSearchResults };
};
